import React from 'react';
import i18next from 'i18next';

import { NormalizedRestaurant } from 'types';
import { hasReservations } from 'utils/restaurant';
import UpdateBanner from '../common/UpdateBanner';

interface IProps {
  restaurant: NormalizedRestaurant;
}

const ReservationReleaseNotes: React.FC<IProps> = ({ restaurant }) => {
  if (!hasReservations(restaurant)) {
    return null;
  }
  return (
    <>
      <UpdateBanner
        canBeClosed={false}
        id="reservation-place-visualization-22-may-2023"
        dateTo="2023-05-24"
      >
        <div className="h5">{i18next.t('reservation-release-notes.may-2023-title')}</div>
        <p>
          {i18next.t('reservation-release-notes.may-2023-description')}
        </p>
        <p>
          <a
            href={'https://www.loom.com/share/6ed47d6fe5754d91b08bae127eb4b043'}
            target="_blank"
            rel="noopener noreferrer"
          >
            {i18next.t('reservation-release-notes.may-2023-video-link')}
          </a>
        </p>
        <div>{i18next.t('reservation-release-notes.may-2023-auto-hide')}</div>
      </UpdateBanner>
      <UpdateBanner
        canBeClosed={false}
        id="reservation-updated-3-april-2023"
        dateTo={'2023-04-06'}
      >
        <div className="h5">
          <p>{i18next.t('reservation-release-notes.april-2023-title')}</p>
          <p>
            <div>
              {i18next.t('reservation-release-notes.april-2023-description')}
            </div>
            <div>{i18next.t('reservation-release-notes.april-2023-auto-hide')}</div>
          </p>

          <p>
            <a
              href={
                'https://www.loom.com/share/08b7a94ff6f04bce9ac913f0ffe3e569'
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              {i18next.t('reservation-release-notes.april-2023-video1-link')}
            </a>
            <span className="ml-2">
              {i18next.t('reservation-release-notes.april-2023-video1-description')}
            </span>
          </p>
          <p>
            <a
              href={
                'https://www.loom.com/share/721e1c1442d84738a9ba764698610a7c'
              }
              target="_blank"
              rel="noopener noreferrer"
            >
              {i18next.t('reservation-release-notes.april-2023-video2-link')}
            </a>
            <span className="ml-2">
              {i18next.t('reservation-release-notes.april-2023-video2-description')}
            </span>
          </p>
        </div>
      </UpdateBanner>
    </>
  );
};

export default ReservationReleaseNotes;
